import moment from 'moment'

export const dateUtil = {
    getDateWithLabel: (label, date) => {
        return `${label}: ${moment(date).utc().format('MMM D, YYYY')}`
    },
    getDateFromWeekAndDayNumber: (year, week, day) => moment().year(year).week(week).day(day),

    ISOToLocalTime: date => (date ? moment(date).utc() : null),

    toISOString: (date, time) =>
        moment(`${date} ${time}`, 'MM/DD/YYYY HH:mm a').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),

    toISOStartOfDate: momentDate => momentDate.format('YYYY-MM-DDT00:00:00.000[Z]'),

    toISOEndOfDate: momentDate => momentDate.format('YYYY-MM-DDT23:59:59.000[Z]'),

    tableDateRange: (start, end) =>
        `${moment(start).utc().format('D MMM')} - ${moment(end).utc().format('D MMM, YYYY')}`,

    ISOtoFullDay: date => moment(date).utc().format('MM/DD/YYYY'),

    betweenIN: (currDate, startDate, endDate) =>
        moment(currDate.format('MM/DD/YYYY')).isBetween(
            dateUtil.ISOtoFullDay(startDate),
            dateUtil.ISOtoFullDay(endDate),
            undefined,
            '[]'
        ),
    /**@param start: {moment}
     **@param end: {moment} */
    dateDiffInSeconds: (start, end) => end.diff(start, 'seconds'),
    getStartOfDay: date => moment(date).startOf('day'),
    getEndOfDay: date => moment(date).endOf('day'),
    getCurrentISODate: () => new Date().toISOString(),
    ISOStartDate: () => moment.format('YYYY-MM-DDT00:00:00.000[Z]'),
    ISOEndDate: () => moment.format('YYYY-MM-DDT23:59:59.000[Z]'),
    formatStartOfDayToISO: (startDate, format) =>
        dateUtil.getStartOfDay(moment(startDate).format(format)).toISOString(),
    formatEndOfDayToISO: (endDate, format) =>
        dateUtil.getEndOfDay(moment(endDate).format(format)).toISOString(),
}
